export const knownEulaStatus = {
    UNKNOWN: 'UNKNOWN',
    ACCEPTED: 'ACCEPTED',
    DECLINED: 'DECLINED',
    REVOKED: 'REVOKED',
    NOT_APPLICABLE: 'NOT_APPLICABLE',
} as const;

export type KnownEulaStatus = (typeof knownEulaStatus)[keyof typeof knownEulaStatus];
